import { COUPON_OPEN_DRAWER, COUPON_DRAWER_LOADED } from '../actionTypes/CouponListActionTypes';

function CouponDrawerReducer(state = { opened: false }, action) {
    switch (action.type) {
        case COUPON_OPEN_DRAWER: {
            const existingState = state.opened;
            if (!existingState) {
                return { ...state, opened: true };
            }
            return state;
        }
        case COUPON_DRAWER_LOADED: {
            return { ...state, isCouponDrawerLoaded: true };
        }
        default:
            return state;
    }
}

CouponDrawerReducer.reducerName = 'couponDrawer';

export default CouponDrawerReducer;
